<template>
  <div>
    <div class="noriceInfo" v-if="!eventId">
      <div class="title">
        <span>当前位置：&nbsp;</span>
        <span>精彩回顾</span>
		<span>></span>
		<span>{{this.$route.query.name}}</span>
        <span style="margin: 0 9px;">></span>
        <span>行业资讯</span>
      </div>
      <div class="content">
        <ul>
          <li
            v-for="(item,index) in informationTypeList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
            :key="index"
            @click="detail(item.id)"
          >
            <div class="leftDiv" v-if="item.remarks">{{ `【${item.remarks}】` + item.title }}</div>
            <div class="leftDiv" v-else>&nbsp; {{ item.title }}</div>
            <div class="rightDiv">{{ item.uploadDate ? item.uploadDate : item.createDate }}</div>
          </li>
        </ul>
      </div>

      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, slot"
        :total="totalPage"
      >
        <el-input type="text" v-model="pageNum"></el-input>
        <el-button class="tz" @click="pageTz">跳转</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      pageNum: null,
      totalPage: 0,
      informationTypeList: [],
      eventId: null,
	  code:"",
    };
  },
  watch: {//地址改变，重新加载数据
    $route(to) { 
      if (to.query.code != this.code || to.query.type != this.type) {
		this.code = to.query.code;
        this.getInformationList();
      }
    },
  },
  created() {
	this.code = this.$route.query.code;
    this.getInformationList();
  },
  methods: {
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum;
    },
    getInformationList() {
      this.$http({
        url: "information/getInformationByTypeList",
        method: "post",
        params: {
		  scheduleId:this.$route.query.code,
          type:"0"
        }
      }).then(response => {
        let { code, zhInformationList } = response.data;
        if (code === 0) {
          this.totalPage = zhInformationList.length;
          zhInformationList.forEach(res => {
            res.createDate = res.createDate.substring(0, 10);
            res.uploadDate = res.uploadDate ? res.uploadDate.substring(0, 10) : "";
          });
          this.informationTypeList = zhInformationList;
        }
      });
    },

    detail(id) {
      this.$router.push({
        path: "/wonderfulReview/wREventsDetails",
        query: {
          code:id,
		  sId:this.$route.query.code,
		  name:this.$route.query.name
        }
      })
    },
  }
};
</script>
<style lang="scss">
.noriceInfo {
  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px;
    color: #eeeeee;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
  .el-pager {
    height: 32px;
    .active {
      background-color: #17327e !important;
    }
    .number {
      height: 100%;
      width: 32px;
      line-height: 32px;
      &:hover {
        background-color: #17327e !important;
        color: #ffffff !important;
      }
    }
  }
  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }
  .el-pagination {
    .el-input {
      width: 32px;
      height: 32px;
      .el-input__inner {
        border-radius: 0;
        width: 32px;
        height: 32px;
        padding: 0;
      }
    }
    .el-button {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      color: #525252;
      margin-left: 8px;
      span {
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.noriceInfo {
  height: 1177px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 11px;
    }
  }
  .content {
    width: 857px;
    height: 958px;
    margin: 10px auto 21px;
    ul {
      list-style: square;
      text-indent: 16px;
      li {
        height: 59px;
        line-height: 59px;
        border-bottom: 1px solid #dfe1e1;
        cursor: pointer;
        .leftDiv {
          float: left;
          font-size: 14px;
          color: #333333;
		  width: 750px;
		  white-space: nowrap;
		  overflow: hidden;
		  text-overflow: ellipsis;
        }
        .rightDiv {
          float: right;
          font-size: 12px;
          color: #bbbbbb;
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
  }
}
</style>